import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  dialog: {
    width: 800,
    maxHeight: '90%',
  },
  mappedField: {
    '& fieldset': {
      borderColor: theme.palette.primary.main,
    },
  },
  mappedFieldWrapper: {
    height: 2,
    background: theme.palette.primary.main,
    position: 'relative',
    marginTop: 2,
    '& span': {
      width: 10,
      height: 10,
      position: 'absolute',
      background: theme.palette.primary.main,
      borderRadius: '50%',
      top: -5,
      right: 0,
    },
  },
}));
